<template>
    <div class="deviceList table-hook fadeInRight">
        <div class="title-box">
            <span class="m-title">设备列表</span>
        </div>
        <div class="search-box">
            <el-form
                :inline="true"
                :model="form"
                class="themed-form search-form search-form-layout"
            >
                <div class="search-left">
                    <el-form-item label="产品范围:">
                        <el-select
                            v-model="form.productName"
                            placeholder="请选择产品"
                            @change="handleProductChange"
                        >
                            <el-option
                                v-for="item in processedAiotProducts"
                                :key="item.key"
                                :label="item.label"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                </div>
                <div class="search-right">
                    <el-form-item>
                        <el-button
                            type="primary"
                            icon="el-icon-plus"
                            class="themed-button"
                            @click="showAddDeviceDialog"
                            >新增设备</el-button
                        >
                    </el-form-item>
                    <el-form-item label="设备名称:">
                        <el-input
                            v-model="form.deviceName"
                            placeholder="请输入设备名称"
                        ></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button
                            type="primary"
                            icon="el-icon-search"
                            class="themed-button"
                            @click="searchData"
                            >搜索</el-button
                        >
                    </el-form-item>
                </div>
            </el-form>
        </div>
        <div class="content-box">
            <el-table
                ref="table"
                :data="tableData"
                stripe
                border
                :max-height="maxTableHeight"
                :empty-text="emptyText"
            >
                <!-- <el-table-column
                    type="index"
                    label="序号"
                    width="60"
                ></el-table-column> -->
                <el-table-column
                    label="设备ID"
                    prop="did"
                    show-overflow-tooltip
                    width="120"
                ></el-table-column>
                <el-table-column
                    label="产品ID"
                    prop="pid"
                    show-overflow-tooltip
                    width="120"
                ></el-table-column>
                <el-table-column
                    label="设备名称"
                    prop="name"
                    show-overflow-tooltip
                    width="150"
                ></el-table-column>
                <!-- <el-table-column
                    label="认证信息"
                    prop="authInfo"
                    show-overflow-tooltip
                    width="150"
                ></el-table-column> -->
                <!-- <el-table-column
                    label="接入点"
                    prop="accessPt"
                    show-overflow-tooltip
                    width="80"
                ></el-table-column>
                <el-table-column
                    label="数据点"
                    prop="dataPt"
                    show-overflow-tooltip
                    width="80"
                ></el-table-column> -->
                <el-table-column
                    label="描述"
                    prop="desc"
                    show-overflow-tooltip
                    min-width="100"
                ></el-table-column>
                <el-table-column
                    label="状态"
                    prop="status"
                    show-overflow-tooltip
                    width="80"
                >
                    <template slot-scope="scope">
                        <span
                            v-if="scope.row.status == 1"
                            style="color: #67c23a"
                            >在线</span
                        >
                        <span
                            v-else-if="scope.row.status == 0"
                            style="color: #909399"
                            >离线</span
                        >
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <!-- <el-table-column
                    label="创建时间"
                    prop="createTime"
                    show-overflow-tooltip
                    width="180"
                >
                    <template slot-scope="scope">
                        {{ formatDateTime(scope.row.createTime) }}
                    </template>
                </el-table-column>
                <el-table-column
                    label="激活时间"
                    prop="activateTime"
                    show-overflow-tooltip
                    width="180"
                >
                    <template slot-scope="scope">
                        {{ formatDateTime(scope.row.activateTime) }}
                    </template>
                </el-table-column> -->
                <el-table-column
                    label="最后通信时间"
                    prop="lastTime"
                    show-overflow-tooltip
                    width="180"
                >
                    <template slot-scope="scope">
                        {{ formatDateTime(scope.row.lastTime) }}
                    </template>
                </el-table-column>
                <!-- <el-table-column
                    label="上联ICCID"
                    prop="upIccid"
                    show-overflow-tooltip
                    width="160"
                ></el-table-column>
                <el-table-column
                    label="上联IMEI"
                    prop="upImei"
                    show-overflow-tooltip
                    width="150"
                ></el-table-column> -->
                <el-table-column
                    label="上联网络"
                    prop="upNetwork"
                    show-overflow-tooltip
                    width="100"
                >
                    <template slot-scope="scope">
                        {{
                            scope.row.upNetwork === 1
                                ? "4G"
                                : scope.row.upNetwork === 2
                                ? "2G"
                                : "-"
                        }}
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="350" fixed="right">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            size="small"
                            @click="showDeviceDetail(scope.row)"
                            >查看详情</el-button
                        >
                        <el-button
                            type="text"
                            size="small"
                            @click="handlePoweroff(scope.row)"
                            >关机</el-button
                        >
                        <el-button
                            type="text"
                            size="small"
                            @click="handleFactoryReset(scope.row)"
                            >恢复出厂</el-button
                        >
                        <el-button
                            type="text"
                            size="small"
                            @click="handleReset(scope.row)"
                            >重启设备</el-button
                        >
                        <el-button
                            type="text"
                            size="small"
                            @click="handleDelete(scope.row)"
                            >删除</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 15, 20, 50, 100]"
                :page-size="pageSize"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
            >
            </el-pagination>
        </div>

        <!-- 设备详情弹窗 -->
        <el-dialog
            title="设备详情"
            :visible.sync="detailDialogVisible"
            width="800px"
        >
            <el-descriptions :column="2" border v-if="deviceDetail">
                <el-descriptions-item label="设备ID">{{
                    deviceDetail.did
                }}</el-descriptions-item>
                <el-descriptions-item label="产品ID">{{
                    deviceDetail.pid
                }}</el-descriptions-item>
                <el-descriptions-item label="设备名称">{{
                    deviceDetail.name
                }}</el-descriptions-item>
                <el-descriptions-item label="认证信息">{{
                    deviceDetail.authInfo
                }}</el-descriptions-item>
                <el-descriptions-item label="接入点">{{
                    deviceDetail.accessPt
                }}</el-descriptions-item>
                <el-descriptions-item label="数据点">{{
                    deviceDetail.dataPt
                }}</el-descriptions-item>
                <el-descriptions-item label="描述" :span="2">{{
                    deviceDetail.desc || "-"
                }}</el-descriptions-item>
                <el-descriptions-item label="状态">
                    <span v-if="deviceDetail.status == 1" style="color: #67c23a"
                        >在线</span
                    >
                    <span
                        v-else-if="deviceDetail.status == 0"
                        style="color: #909399"
                        >离线</span
                    >
                    <span v-else>-</span>
                </el-descriptions-item>
                <el-descriptions-item label="启用状态">
                    {{ deviceDetail.enableStatus ? "启用" : "禁用" }}
                </el-descriptions-item>
                <el-descriptions-item label="创建时间">{{
                    formatDateTime(deviceDetail.createTime)
                }}</el-descriptions-item>
                <el-descriptions-item label="激活时间">{{
                    formatDateTime(deviceDetail.activateTime)
                }}</el-descriptions-item>
                <el-descriptions-item label="最后通信时间">{{
                    formatDateTime(deviceDetail.lastTime)
                }}</el-descriptions-item>
                <el-descriptions-item label="上联ICCID">{{
                    deviceDetail.upIccid || "-"
                }}</el-descriptions-item>
                <el-descriptions-item label="上联IMEI">{{
                    deviceDetail.upImei || "-"
                }}</el-descriptions-item>
                <el-descriptions-item label="上联网络">
                    {{
                        deviceDetail.upNetwork === 1
                            ? "4G"
                            : deviceDetail.upNetwork === 2
                            ? "2G"
                            : "-"
                    }}
                </el-descriptions-item>
                <el-descriptions-item label="IMSI">{{
                    deviceDetail.imsi || "-"
                }}</el-descriptions-item>
                <el-descriptions-item label="IMEI">{{
                    deviceDetail.imei || "-"
                }}</el-descriptions-item>
                <el-descriptions-item label="PSK">{{
                    deviceDetail.psk || "-"
                }}</el-descriptions-item>
                <el-descriptions-item label="群组ID">{{
                    deviceDetail.groupId || "-"
                }}</el-descriptions-item>
                <el-descriptions-item label="认证码">{{
                    deviceDetail.authCode || "-"
                }}</el-descriptions-item>
                <el-descriptions-item label="芯片">{{
                    deviceDetail.chip
                }}</el-descriptions-item>
                <el-descriptions-item label="观察状态">{{
                    deviceDetail.obsv ? "是" : "否"
                }}</el-descriptions-item>
                <el-descriptions-item label="观察状态数据">{{
                    deviceDetail.obsvSt ? "是" : "否"
                }}</el-descriptions-item>
                <el-descriptions-item label="私有">{{
                    deviceDetail.isPrivate ? "是" : "否"
                }}</el-descriptions-item>
                <el-descriptions-item label="智能方式">{{
                    deviceDetail.intelligentWay
                }}</el-descriptions-item>
            </el-descriptions>

            <!-- 设备属性 -->
            <el-divider content-position="left">设备属性</el-divider>
            <div
                v-if="deviceProperties && deviceProperties.length > 0"
                class="property-wrapper"
            >
                <div
                    v-for="(item, index) in deviceProperties"
                    :key="index"
                    class="property-item"
                >
                    <span class="property-label">{{ item.name || "-" }}：</span>
                    <span class="property-value">
                        <span v-if="item.identifier === 'device_conn_status'">
                            <span
                                v-if="
                                    item.value === true ||
                                    item.value === 'true' ||
                                    item.value === 1 ||
                                    item.value === '1'
                                "
                                style="color: #67c23a"
                                >在线</span
                            >
                            <span
                                v-else-if="
                                    item.value === false ||
                                    item.value === 'false' ||
                                    item.value === 0 ||
                                    item.value === '0'
                                "
                                style="color: #909399"
                                >离线</span
                            >
                            <span v-else>-</span>
                        </span>
                        <span
                            v-else-if="
                                item.value_type === 'bool' ||
                                item.data_type === 'bool'
                            "
                        >
                            {{
                                item.value === true ||
                                item.value === "true" ||
                                item.value === true
                                    ? "是"
                                    : "否"
                            }}
                        </span>
                        <span v-else-if="item.identifier === 'lte_info'">
                            {{ formatLteInfo(item.value) }}
                        </span>
                        <!-- <span v-else-if="item.identifier === 'run_time'">
                            {{ formatRunTime(item.value) }}
                        </span> -->
                        <span v-else-if="item.identifier === 'wifi_enabled'">
                            <el-switch
                                v-model="wifiSwitchValue"
                                :active-value="1"
                                :inactive-value="0"
                                active-text="开启"
                                inactive-text="关闭"
                                @change="handleWifiSwitchChange"
                            ></el-switch>
                        </span>
                        <span v-else-if="item.identifier === 'hidden'">
                            <el-switch
                                v-model="hiddenSwitchValue"
                                :active-value="1"
                                :inactive-value="0"
                                active-text="显示热点"
                                inactive-text="隐藏热点"
                                @change="handleHiddenSwitchChange"
                            ></el-switch>
                        </span>
                        <span v-else>{{ item.value || "-" }}</span>
                    </span>
                </div>
            </div>
            <div
                v-else
                style="text-align: center; color: #909399; padding: 20px"
            >
                暂无设备属性数据
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="detailDialogVisible = false"
                    >关 闭</el-button
                >
            </span>
        </el-dialog>

        <!-- 新增设备对话框 -->
        <el-dialog
            title="新增设备"
            :visible.sync="addDeviceDialogVisible"
            width="600px"
        >
            <el-form
                :model="addDeviceForm"
                :rules="addDeviceRules"
                ref="addDeviceForm"
                label-width="100px"
            >
                <el-form-item label="产品范围:" prop="productid">
                    <el-select
                        v-model="addDeviceForm.productName"
                        placeholder="请选择产品"
                        style="width: 100%"
                        @change="handleAddDeviceProductChange"
                    >
                        <el-option
                            v-for="item in processedAiotProducts"
                            :key="item.key"
                            :label="item.label"
                            :value="item.value"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="设备名称:" prop="deviceName">
                    <el-input
                        v-model="addDeviceForm.deviceName"
                        placeholder="请输入设备名称"
                    ></el-input>
                </el-form-item>
                <el-form-item label="描述:" prop="desc">
                    <el-input
                        v-model="addDeviceForm.desc"
                        type="textarea"
                        rows="3"
                        placeholder="请输入设备描述"
                    ></el-input>
                </el-form-item>
                <el-form-item label="经度:" prop="lon">
                    <el-input
                        v-model="addDeviceForm.lon"
                        placeholder="请输入经度"
                    ></el-input>
                </el-form-item>
                <el-form-item label="纬度:" prop="lat">
                    <el-input
                        v-model="addDeviceForm.lat"
                        placeholder="请输入纬度"
                    ></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addDeviceDialogVisible = false"
                    >取 消</el-button
                >
                <el-button type="primary" @click="submitAddDevice"
                    >确 定</el-button
                >
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {
    getDeviceList,
    getDeviceDetail,
    getDeviceProperty,
    setWifiEnabled,
    setWifiHidden,
    setDeviceConnStatus,
    poweroffDevice,
    factoryResetDevice,
    resetDevice,
    createDevice,
    deleteDevice,
} from "@/api/aiotPlatform/device.js";
import resize from "@/mixins/resize.js";
import dictGroup from "@/mixins/dictGroup.js";

export default {
    name: "AiotPlatformDeviceList",
    mixins: [resize, dictGroup],
    data() {
        return {
            form: {
                productid: "", // 存储产品ID（key），用于API提交
                productName: "", // 存储产品key（用于下拉框绑定的值）
                deviceName: "",
            },
            tableData: [],
            pageSize: 15,
            currentPage: 1,
            total: 0,
            maxTableHeight: 500,
            detailDialogVisible: false, // 详情弹窗显示
            deviceDetail: null, // 设备详情数据
            deviceProperties: [], // 设备属性数据
            wifiSwitchValue: 0, // WiFi开关值
            hiddenSwitchValue: 0, // WiFi热点隐藏开关值
            connStatusSwitchValue: false, // 设备在线状态开关值
            currentDeviceInfo: null, // 当前操作的设备信息
            addDeviceDialogVisible: false, // 新增设备弹窗显示
            addDeviceForm: {
                productid: "", // 产品ID（实际值）
                productName: "", // 产品名称（显示值）
                deviceName: "", // 设备名称
                desc: "", // 描述
                lon: "", // 经度
                lat: "", // 纬度
                tags: "", // 标签
            },
            addDeviceRules: {
                productid: [
                    {
                        required: true,
                        message: "请选择产品",
                        trigger: "change",
                    },
                ],
                deviceName: [
                    {
                        required: true,
                        message: "请输入设备名称",
                        trigger: "blur",
                    },
                ],
            },
        };
    },
    computed: {
        aiotProducts() {
            console.log(this.w_AIOT_, "this.w_AIOT_");
            return this.w_AIOT_ || [];
        },
        // 处理后的产品列表，解析dictValue JSON
        processedAiotProducts() {
            const products = this.aiotProducts;
            if (!products || products.length === 0) {
                return [];
            }

            const thirdItem = products[3];
            if (!thirdItem || !thirdItem.dictValue) {
                return [];
            }

            try {
                // 解析dictValue JSON字符串
                const dictValueObj = JSON.parse(thirdItem.dictValue);

                // 将对象转换为数组格式 [{key, label, value}]
                const processedList = [];
                for (const [key, value] of Object.entries(dictValueObj)) {
                    processedList.push({
                        key: key,
                        label: value, // 下拉框显示值
                        value: key, // 下拉框绑定值
                    });
                }

                return processedList;
            } catch (error) {
                console.error("解析dictValue失败:", error);
                return [];
            }
        },
        emptyText() {
            return this.form.productid ? "暂无数据" : "请选择产品范围";
        },
    },
    mounted() {
        // mounted阶段不自动请求列表数据
    },
    activated() {
        this.getList();
    },
    methods: {
        // 获取列表数据
        getList() {
            const params = {
                productId: this.form.productid,
                deviceName: this.form.deviceName,
                offset: (this.currentPage - 1) * this.pageSize,
                limit: this.pageSize,
            };

            getDeviceList(params)
                .then((res) => {
                    if (res && res.list && Array.isArray(res.list)) {
                        this.tableData = res.list;
                        this.total = res.total; // 暂时使用列表长度，接口返回total后再替换，接口里没有total会导致分页错误
                    } else {
                        this.tableData = [];
                        this.total = 0;
                    }
                })
                .catch((err) => {
                    console.error("获取设备列表失败:", err);
                    this.$message.error("获取设备列表失败");
                    this.tableData = [];
                    this.total = 0;
                });
        },

        // 搜索
        searchData() {
            this.currentPage = 1;
            this.getList();
        },

        // 分页处理
        handleSizeChange(val) {
            this.pageSize = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getList();
        },

        // 产品选择变化
        handleProductChange(value) {
            // value是选中的key
            const selectedProduct = this.processedAiotProducts.find(
                (item) => item.key === value
            );
            if (selectedProduct) {
                // form.productName存储key，这样下拉框能正确回显
                this.form.productName = selectedProduct.key;
                // form.productid存储key，用于API提交
                this.form.productid = selectedProduct.key;
            } else {
                console.error("未找到对应的产品");
                this.form.productid = "";
                this.form.productName = "";
            }
            this.currentPage = 1;
            this.getList();
        },

        // 格式化日期时间
        formatDateTime(dateTime) {
            if (!dateTime) return "-";
            try {
                const date = new Date(dateTime);
                if (isNaN(date.getTime())) return dateTime;
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, "0");
                const day = String(date.getDate()).padStart(2, "0");
                const hours = String(date.getHours()).padStart(2, "0");
                const minutes = String(date.getMinutes()).padStart(2, "0");
                const seconds = String(date.getSeconds()).padStart(2, "0");
                return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
            } catch (error) {
                console.error("日期格式化错误:", error);
                return dateTime;
            }
        },

        // 显示设备详情
        showDeviceDetail(row) {
            this.deviceDetail = null;
            this.deviceProperties = [];
            this.wifiSwitchValue = 0;
            this.hiddenSwitchValue = 0;
            this.connStatusSwitchValue = false;
            this.currentDeviceInfo = row;
            this.detailDialogVisible = true;

            const params = {
                productId: this.form.productid,
                deviceName: row.name || row.deviceName,
            };

            getDeviceDetail(params)
                .then((res) => {
                    if (res && typeof res === "object" && res.did) {
                        this.deviceDetail = res;
                    } else {
                        this.$message.error("获取设备详情失败");
                    }
                })
                .catch((err) => {
                    console.error("获取设备详情失败:", err);
                    this.$message.error("获取设备详情失败");
                });

            // 请求设备属性
            getDeviceProperty(params)
                .then((res) => {
                    if (res && typeof res === "string") {
                        try {
                            const propertyData = JSON.parse(res);
                            if (
                                propertyData &&
                                propertyData.data &&
                                Array.isArray(propertyData.data)
                            ) {
                                this.deviceProperties = propertyData.data;
                            }
                        } catch (error) {
                            console.error("解析属性数据失败:", error);
                        }
                    } else if (res && Array.isArray(res)) {
                        this.deviceProperties = res;
                    }

                    // 设置WiFi开关的初始值
                    const wifiProperty = this.deviceProperties.find(
                        (item) => item.identifier === "wifi_enabled"
                    );
                    if (wifiProperty) {
                        this.wifiSwitchValue =
                            wifiProperty.value === "1" ||
                            wifiProperty.value === 1
                                ? 1
                                : 0;
                    }

                    // 设置WiFi热点隐藏开关的初始值
                    const hiddenProperty = this.deviceProperties.find(
                        (item) => item.identifier === "hidden"
                    );
                    if (hiddenProperty) {
                        this.hiddenSwitchValue =
                            hiddenProperty.value === "1" ||
                            hiddenProperty.value === 1
                                ? 1
                                : 0;
                    }

                    // 设置设备在线状态开关的初始值
                    const connStatusProperty = this.deviceProperties.find(
                        (item) => item.identifier === "device_conn_status"
                    );
                    if (connStatusProperty) {
                        this.connStatusSwitchValue =
                            connStatusProperty.value === true ||
                            connStatusProperty.value === "true" ||
                            connStatusProperty.value === 1 ||
                            connStatusProperty.value === "1";
                    }
                })
                .catch((err) => {
                    console.error("获取设备属性失败:", err);
                });
        },

        // WiFi开关变化处理
        handleWifiSwitchChange(value) {
            const oldValue = this.wifiSwitchValue === 1 ? 0 : 1;

            const params = {
                productId: this.form.productid,
                deviceName:
                    this.currentDeviceInfo?.name ||
                    this.currentDeviceInfo?.deviceName,
                value: value,
            };

            setWifiEnabled(params)
                .then((res) => {
                    this.$message.success(
                        value === 1 ? "WiFi已开启" : "WiFi已关闭"
                    );
                })
                .catch((err) => {
                    console.error("设置WiFi开关失败:", err);
                    this.$message.error("设置WiFi开关失败");
                    this.wifiSwitchValue = oldValue;
                });
        },

        // WiFi热点隐藏开关变化处理
        handleHiddenSwitchChange(value) {
            const oldValue = this.hiddenSwitchValue === 1 ? 0 : 1;

            const params = {
                productId: this.form.productid,
                deviceName:
                    this.currentDeviceInfo?.name ||
                    this.currentDeviceInfo?.deviceName,
                value: value,
            };

            setWifiHidden(params)
                .then((res) => {
                    this.$message.success(
                        value === 1 ? "热点已显示" : "热点已隐藏"
                    );
                })
                .catch((err) => {
                    console.error("设置WiFi热点隐藏失败:", err);
                    this.$message.error("设置WiFi热点隐藏失败");
                    this.hiddenSwitchValue = oldValue;
                });
        },

        // 设备在线状态开关变化处理
        handleConnStatusSwitchChange(value) {
            const oldValue = this.connStatusSwitchValue;

            const params = {
                productId: this.form.productid,
                deviceName:
                    this.currentDeviceInfo?.name ||
                    this.currentDeviceInfo?.deviceName,
                value: value ? "1" : "0",
            };

            setDeviceConnStatus(params)
                .then((res) => {
                    this.$message.success(value ? "设备已激活" : "设备已停用");
                })
                .catch((err) => {
                    console.error("设置设备在线状态失败:", err);
                    this.$message.error("设置设备在线状态失败");
                    this.connStatusSwitchValue = oldValue;
                });
        },

        formatLteInfo(value) {
            if (!value) return "-";
            try {
                let lteData = value;
                if (typeof value === "string") {
                    lteData = JSON.parse(value);
                }
                if (typeof lteData === "object" && lteData !== null) {
                    const parts = [];
                    for (const key in lteData) {
                        if (
                            lteData.hasOwnProperty(key) &&
                            lteData[key] !== null &&
                            lteData[key] !== undefined &&
                            lteData[key] !== ""
                        ) {
                            parts.push(`${key}: ${lteData[key]}`);
                        }
                    }
                    return parts.length > 0 ? parts.join(", ") : "-";
                }

                return value;
            } catch (error) {
                console.error("解析基站信息失败:", error);
                return value || "-";
            }
        },

        formatRunTime(runSeconds) {
            if (!runSeconds && runSeconds !== 0) return "-";
            const runTime = parseInt(runSeconds);
            if (isNaN(runTime)) return runSeconds;
            const currentTime = Date.now();
            const deviceStartTime = currentTime - runTime * 1000;
            return this.formatDateTime(new Date(deviceStartTime).toISOString());
        },

        // 关机
        handlePoweroff(row) {
            this.$confirm("确认关机该设备吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    const params = {
                        productId: this.form.productid,
                        deviceName: row.name || row.deviceName,
                    };

                    poweroffDevice(params)
                        .then((res) => {
                            this.$message.success("设备关机成功");
                        })
                        .catch((err) => {
                            console.error("关机失败:", err);
                            this.$message.error("设备关机失败");
                        });
                })
                .catch(() => {});
        },

        // 恢复出厂
        handleFactoryReset(row) {
            this.$confirm(
                "恢复出厂设置将清除所有数据，确认要继续吗？",
                "警告",
                {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                }
            )
                .then(() => {
                    const params = {
                        productId: this.form.productid,
                        deviceName: row.name || row.deviceName,
                    };

                    factoryResetDevice(params)
                        .then((res) => {
                            this.$message.success("设备已恢复出厂设置");
                        })
                        .catch((err) => {
                            console.error("恢复出厂失败:", err);
                            this.$message.error("恢复出厂设置失败");
                        });
                })
                .catch(() => {});
        },

        // 重启设备
        handleReset(row) {
            this.$confirm("确认重启该设备吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    const params = {
                        productId: this.form.productid,
                        deviceName: row.name || row.deviceName,
                    };

                    resetDevice(params)
                        .then((res) => {
                            this.$message.success("设备重启成功");
                        })
                        .catch((err) => {
                            console.error("重启失败:", err);
                            this.$message.error("设备重启失败");
                        });
                })
                .catch(() => {});
        },

        // 删除
        handleDelete(row) {
            this.$confirm("确认删除该设备吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    const params = {
                        productId: this.form.productid,
                        deviceName: row.name || row.deviceName,
                        // imei: row.upImei || "",
                    };

                    deleteDevice(params)
                        .then((res) => {
                            this.$message.success("设备删除成功");
                            this.getList(); // 刷新列表
                        })
                        .catch((err) => {
                            console.error("删除失败:", err);
                            this.$message.error("设备删除失败");
                        });
                })
                .catch(() => {});
        },

        // 显示新增设备弹窗
        showAddDeviceDialog() {
            this.addDeviceForm = {
                productid: "",
                productName: "",
                deviceName: "",
                desc: "",
                lon: "",
                lat: "",
                tags: "",
            };
            this.addDeviceDialogVisible = true;
        },

        // 新增设备产品选择变化
        handleAddDeviceProductChange(value) {
            // value是选中的key
            const selectedProduct = this.processedAiotProducts.find(
                (item) => item.key === value
            );
            if (selectedProduct) {
                // addDeviceForm.productName存储key，这样下拉框能正确回显
                this.addDeviceForm.productName = selectedProduct.key;
                // addDeviceForm.productid存储key，用于API提交
                this.addDeviceForm.productid = selectedProduct.key;
            } else {
                console.error("未找到对应的产品");
                this.addDeviceForm.productid = "";
                this.addDeviceForm.productName = "";
            }
        },

        // 提交新增设备
        submitAddDevice() {
            this.$refs["addDeviceForm"].validate((valid) => {
                if (valid) {
                    const params = {
                        productId: this.addDeviceForm.productid,
                        deviceName: this.addDeviceForm.deviceName,
                        desc: this.addDeviceForm.desc || "",
                        lon: this.addDeviceForm.lon || "",
                        lat: this.addDeviceForm.lat || "",
                        tags: this.addDeviceForm.tags || "",
                    };

                    createDevice(params)
                        .then((res) => {
                            this.$message.success("设备新增成功");
                            this.addDeviceDialogVisible = false;
                            this.getList();
                        })
                        .catch((err) => {
                            console.error("新增设备失败:", err);
                            this.$message.error("新增设备失败");
                        });
                }
            });
        },
    },
};
</script>

<style scoped>
.deviceList {
    padding: 20px;
}

.content-box {
    margin-bottom: 20px;
}

.pagination {
    text-align: right;
    margin-top: 20px;
}

.search-box {
    padding: 10px 20px;
    background-color: #ffffff;
    border-radius: 4px;
}

.search-form-layout {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.search-left {
    display: inline-block;
}

.search-right {
    display: inline-block;
}

.search-box .el-form-item {
    margin-bottom: 0;
}

.search-box .el-form-item__label {
    padding-right: 8px;
}

.property-wrapper {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(45%, 1fr));
    gap: 12px;
}

.property-item {
    display: flex;
    align-items: flex-start;
    border-bottom: 1px solid #ebeef5;
    padding-bottom: 8px;
}

.property-label {
    min-width: 120px;
    color: #909399;
    flex-shrink: 0;
}

.property-value {
    flex: 1;
    color: #606266;
    word-break: break-all;
}
</style>
